import React from 'react'
import { Formik } from 'formik'
import styled from 'styled-components'
import * as yup from 'yup'
import { InputsContainer } from '../../../../components/ui/form'
import { Button } from '../../../../components/ui/button'
import useIsMobile from '../../../../hooks/useIsMobile'
import Autocomplete from '../../../../components/ui/autoComplete'

const Container = styled.div`
	width: 360px;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 100%;
	}
`

const Title = styled.h1`
	font-size: 24px;
	color: #333;
	margin-bottom: 10px;
	font-weight: 600;
`

const InitialForm = ({
	onNext,
	onUpdateFormData,
	formData,
	clinics,
	specialties,
	professionals,
	getProfessionals
}) => {
	const isMobile = useIsMobile()
	const validations = yup.object().shape({
		speciality: yup.string().required('Campo requerido'),
		clinic: yup.string().nullable().required('Campo requerido'),
		professional: yup.string().nullable()
	})

	const handleFormSubmit = values => {
		onNext(values)
	}

	const onChangeSpeciality = (speciality, setFieldValue) => {
		setFieldValue('speciality', speciality)
		setFieldValue('professional', null)
		setFieldValue('clinic', null)
		setFieldValue('clinicCode', null)
		onUpdateFormData &&
			onUpdateFormData({
				speciality,
				professional: null,
				clinic: null,
				clinicCode: null
			})
	}

	const onChangeClinic = (e, setFieldValue, speciality) => {
		const clinicValue = e?.target?.value ?? e
		const clinicOption = clinics.find(c => c.value === clinicValue)
		setFieldValue('professional', null)
		setFieldValue('clinic', clinicValue)
		setFieldValue('clinicCode', clinicOption?.codigoEmpresa || '')
		onUpdateFormData &&
			onUpdateFormData({ clinic: clinicValue, clinicCode: clinicOption?.codigoEmpresa || '' })
		if(clinicOption?.codigoEmpresa && speciality) {
			getProfessionals(speciality, clinicOption?.codigoEmpresa)
		}
	}

	return (
		<Container>
			<Title align={'start'}>Programá tu turno presencial</Title>
			<Formik
				initialValues={formData}
				validationSchema={validations}
				onSubmit={handleFormSubmit}
				validateOnChange
				validateOnBlur
			>
				{({ values, errors, touched, handleSubmit, setFieldValue }) => (
					<InputsContainer gap={24} mb={16} heightMobile="100%">
						<Autocomplete
							label={'Especialidad'}
							name="speciality"
							value={values.speciality}
							onChange={e => onChangeSpeciality(e.target?.value || e, setFieldValue)}
							options={specialties}
							error={touched.speciality && errors.speciality}
							placeholder="Seleccione una especialidad"
						/>
						<Autocomplete
							label={'Clínica / Centro médico'}
							name="clinic"
							value={values.clinic}
							onChange={e => onChangeClinic(e, setFieldValue, values.speciality)}
							options={clinics}
							error={touched.clinic && errors.clinic}
							isClearable
							disabled={!values.speciality}
							placeholder={
								!values.speciality ? 'Primero seleccione especialidad' : 'Seleccione una clínica'
							}
						/>
						<Autocomplete
							label={'Profesional (Opcional)'}
							name="professional"
							value={values.professional}
							onChange={e => setFieldValue('professional', e.target?.value || null)}
							options={professionals}
							error={touched.professional && errors.professional}
							isClearable
							disabled={!values.speciality || !values.clinic}
							placeholder={
								!values.speciality || !values.clinic
									? 'Primero seleccione especialidad y clínica'
									: 'Seleccione un profesional'
							}
						/>
						<Button
							onClick={handleSubmit}
							type="submit"
							label={'Continuar'}
							size={isMobile ? 'mobile' : 'xlarge'}
							disabled={!values.speciality || !values.clinic}
						/>
					</InputsContainer>
				)}
			</Formik>
		</Container>
	)
}

export default InitialForm
